<template>
  <b-row class="next-steps">
    <b-col md="6" class="next-steps__element">
      <feature-card
        class="h-100"
        icon="email"
        title="Email di conferma"
        text="Riceverai una email con tutti i dettagli della tua Gift Card e le istruzioni per l'utilizzo."
        caption="Controlla anche la cartella spam se non la vedi nella posta in arrivo"
        :title_size="18"
        icon_background_color="#e9ecef"
        radius
      />
    </b-col>

    <b-col md="6" class="next-steps__element">
      <feature-card
        class="h-100"
        icon="download"
        title="Scarica PDF"
        text="Scarica la versione PDF della tua Gift Card da stampare o conservare."
        :title_size="18"
        icon_background_color="#e9ecef"
        radius
      >
        <!--
          in attesa del PDF dal backend la card si porta a casa con la stampa del
          browser: il foglio contiene la sola gift card (vedi le regole @media print
          della vista di conferma)
        -->
        <button
          type="button"
          class="next-steps__link"
          @click="print_page()"
        >
          Scarica la gift card
        </button>
      </feature-card>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'next-steps',

    methods: {
      /**
       * Stampa della pagina.
       *
       * Passa da un metodo e non da `window.print()` nel template: in sviluppo il
       * render di Vue gira dietro un Proxy che non lascia risolvere `window` sul
       * globale (non è fra i suoi `allowedGlobals`), quindi lì l'handler inline
       * andrebbe in TypeError. In produzione il Proxy non c'è e funzionerebbe:
       * il pulsante si sarebbe rotto solo per chi sviluppa.
       */
      print_page() {
        window.print();
      },
    },
  };
</script>

<style lang="scss" scoped>

  .next-steps {

    &__element {
      margin-bottom: $grid-gutter-width / 2;

      @include media-breakpoint-up(md) {
        margin-bottom: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__link {
      padding: 0;
      margin-top: $grid-gutter-width / 2;
      font-size: $font-size-md;
      color: $info;
      text-decoration: underline;
      background: none;
      border: 0;
    }
  }
</style>
